// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"af41a08f","238":"bc1380a3","411":"1e5f260f","723":"cf7f6dcd","728":"ae7fad74","732":"ecc829e4","872":"3a92a26d","977":"2987bcdf"}[chunkId] + ".chunk.js";
};